export default __webpack_public_path__ + "static/media/fruitonthestair.158af0f9.jpg";